import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Utils/debugNotifiction/debugNotification.component"
    ).then((module) => ({
        default: module.DebugNotification
    }))
);
